import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FranticFanficUser, PlayerDetails, PlayerId, User } from "../../types";

interface MenuState {
  playerDetails?: PlayerDetails;
  playerId?: PlayerId; // after joining game but before websocket connection
  hiddenCode: boolean;
  hiddenSubheaders: boolean;
  user?: User;
  authLoading: boolean; // Tracks Auth0 authentication state resolution
}

const initialMenuState: MenuState = {
  hiddenCode: false,
  hiddenSubheaders: false,
  authLoading: true, // Start as loading until Auth0 resolves
};

const menuSlice = createSlice({
  name: "menuSlice",
  initialState: initialMenuState,
  reducers: {
    updateUser: (state, action: PayloadAction<User | undefined>) => {
      state.user = action.payload;
    },
    updateFranticFanficUser: (
      state,
      action: PayloadAction<FranticFanficUser>
    ) => {
      if (state.user) {
        state.user.rank = action.payload.rank;
        state.user.user_id = action.payload.user_id;
      }
    },
    updatePlayerDetails: (state, action: PayloadAction<PlayerDetails>) => {
      state.playerDetails = action.payload;
    },
    updatePlayerId: (state, action: PayloadAction<PlayerId>) => {
      state.playerId = { ...state.playerDetails, ...action.payload };
    },
    clearRoom: (state) => {
      state.playerId = undefined;
    },
    updateHiddenCode: (state, action: PayloadAction<boolean>) => {
      state.hiddenCode = action.payload;
    },
    updateHiddenSubheaders: (state, action: PayloadAction<boolean>) => {
      state.hiddenSubheaders = action.payload;
    },
    setAuthLoading: (state, action: PayloadAction<boolean>) => {
      state.authLoading = action.payload;
    },
  },
});

export const {
  updatePlayerDetails,
  updatePlayerId,
  clearRoom,
  updateHiddenCode,
  updateUser,
  
  updateHiddenSubheaders,
  setAuthLoading,
} = menuSlice.actions;

export const menuReducer = menuSlice.reducer;

// Selectors
export const selectUser = (state: { menu: MenuState }) => state.menu.user;
